import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.3818 17.3513L20 18.9738L21.618 17.3513L23.0342 18.7634L20.0002 21.8062L16.9657 18.7636L18.3818 17.3513Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.3808 16.6366L20 15.0152L21.6189 16.6366L23.0342 15.2234L20.0002 12.1848L16.9657 15.2233L18.3808 16.6366Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 3H21L14 12.8174V21H10V12.8174L3 3Z"}}]};

const FilterSortFilled = Vue.extend<IconProps>({
  name: 'FilterSortFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'filter-sort-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FilterSortFilled;
